<template>
  <!-- 耕雲導師墨寶 -->
  <div class="taoist">
    <div v-for="(item, index) in content" :key="index">
      <div class="flex-between title">
        <div class="titleLeft">{{ item.cate_name }}</div>
      </div>
      <!-- 二级列表 -->
      <div>
        <div
          class="content oneLine"
          v-for="(item1, index1) in item.lists"
          :key="index1"
          @click="linkToDetail(item1)"
        >
          {{ index1 + 1 }}.{{ item1.news_title }}
        </div>
      </div>
      <barF5></barF5>
    </div>
  </div>
</template>

<script>
import { getInkList } from "../../api/apis";

import point from "../../components/point";
import barF5 from "../../components/barF5";
export default {
  name: "",
  components: {
    point,
    barF5,
  },
  props: ["cateId", "title"],
  data() {
    return {
      contentStatus: [false, false, false], //控制展开和结束
      content: [
        // {
        // id: 18,
        // cate_name: "(一) 　诗歌、铭言及法语摘要",
        // lists: [
        // {
        //     id: 5,
        //     news_title: "安祥天使"
        // },
        // {
        //     id: 4,
        //     news_title: "安　祥"
        // },
        // {
        //     id: 2,
        //     news_title: "安祥禅简介"
        // },
        // {
        //     id: 2,
        //     news_title: "安祥禅简介"
        // }
        //     ]
        // }
      ],
    };
  },
  methods: {
    changShowList(index) {
      // this.contentStatus.splice(index, 1, !this.contentStatus[index]);
    },
    //文章详情
    linkToDetail(item) {
      this.$router.push({
        path: "/articleDetail",
        query: { name: "taoist", id: item.id, title: this.title },
      });
    },
  },
  mounted() {
    this.cateId = this.cateId || 3;
    getInkList(this.cateId).then((res) => {
      this.content = res;
      //初始化contentStatus
      // let array = [];
      // for(let i=0;i<res.length;i++){
      //     array[i] = false;
      // }
      // this.contentStatus = array;
    });
  },
};
</script>

<style scoped>
.taoist {
  color: #333333;
  font-size: 0.85rem;
}

.title {
  padding: 0.64rem;
}

.titleLeft {
  font-size: 0.85rem;
  /*font-weight: 600;*/
  line-height: 1.8rem;
  font-weight: bold;
  /* margin-left:-0.3rem;微调 */
  width: 100%;
}

.content {
  font-size: 0.85rem;
  height: 2.4rem;
  border-top: 1px dashed #dfdfdf;
  line-height: 2.8rem;
  padding-left: 0.64rem;
  padding-right: 0.64rem;
}

.expand {
  font-size: 0.69rem;
  /* width: 3.6rem; */
}
.openBtn {
}
/* .down {
    width: 0.64rem;
    height: 0.32rem;
    background: rgba(0, 0, 0, 1);
    opacity: 1;
  } */
.down img {
  width: 0.64rem;
  height: 0.32rem;
  margin-left: 0.2rem;
}
</style>